<template>
	<div :class="contextualClasses" class="v-contextual v-contextual--content">
		<div :class="triggerClasses" class="v-contextual__trigger">
			<div
				@click.prevent="click()"
				@mouseleave.prevent.stop="mouseleave()"
				@mouseenter.prevent.stop="mouseenter()">
				<slot :on="on" :toggle="toggle" name="trigger">
					<button></button>
				</slot>
			</div>
		</div>
		<div
			v-show="on"
			:id="menuId"
			:aria-hidden="!on"
			:aria-labelledby="triggerId"
			:class="contentClasses"
			:style="styles" class="v-contextual__content"
			@mouseenter="preventTimeout()"
			@mouseleave="mouseleave()">
			<slot :on="on" :toggle="toggle"/>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			on: false,
			timeout: null,
			styles: {},
			scrollHandler: null,
		};
	},

	computed: {
		contextualClasses() {
			return {
				"v-contextual--content--on": this.on,
			};
		},
		triggerClasses() {
			return {
				"v-contextual__trigger--on": this.on,
			};
		},
		contentClasses() {
			return {
				"v-contextual__content--on": this.on,
				// "v-contextual__content--left": this.align === "left",
				// "v-contextual__content--right": this.align === "right",
			};
		},
		triggerId() {
			return "v-contextual__trigger--" + this.id;
		},
		menuId() {
			return "v-contextual__content--" + this.id;
		},
	},

	props: {
		id: {
			type: String,
			default() {
				return String(this._uid);
			},
		},
		disabled: {
			type: Boolean,
			default() {
				return false;
			},
		},
		toggleOnHover: {
			type: Boolean,
			default() {
				return false;
			},
		},
		align: {
			required: false,
			type: String,
			default() {
				return "left";
			},
		},
	},

	methods: {
		toggle() {
			this.on = !this.on;
			this.setPosition();
			this.$emit("toggled", this.on);
		},
		click() {
			if (this.toggleOnHover) {
				return;
			}

			this.toggle();
		},
		mouseenter() {
			if (!this.toggleOnHover) {
				return;
			}

			this.preventTimeout();

			this.show();
		},
		mouseleave(immediate = false) {
			if (!this.toggleOnHover) {
				return;
			}

			if (!immediate) {
				this.timeout = setTimeout(() => {
					this.hide();
				}, 150);
				return;
			}

			clearTimeout(this.timeout);
			this.timeout = null;
			this.hide();
		},
		preventTimeout() {
			clearTimeout(this.timeout);
			this.timeout = null;
		},
		show() {
			this.on = true;
			this.setPosition();
		},
		hide() {
			this.on = false;
		},
		hideOnClickOutside(event) {
			if (this.$el.contains(event.target)) {
				return;
			}
			this.hide();
		},
		setPosition() {
			if (!this.on) {
				return;
			}

			this.$set(this.styles, "top", (this.$el?.getBoundingClientRect().top + this.$el?.getBoundingClientRect().height) + "px");

			switch (this.align) {
				case "left":
					this.$set(this.styles, "left", this.$el?.getBoundingClientRect().left + "px");
					break;
				case "right":
					this.$set(this.styles, "right", (window.innerWidth - this.$el?.getBoundingClientRect().right) + "px");
					break;
			}
		},
		preventScroll(e) {
			if (!this.on) {
				return;
			}
			e.preventDefault();
		},
		// scrollHandler: new _.debounce(function () {
		// 	this.setPosition();
		// }, 1000),
	},

	mounted() {
		// this.scrollHandler = _.debounce(() => {
		// 	this.setPosition();
		// }, 1000);
		this.scrollHandler = (event) => {
			// this.preventScroll(event);
			this.setPosition();
		};
		window.addEventListener("scroll", this.scrollHandler, true);
		window.addEventListener("click", this.hideOnClickOutside);
	},

	destroyed() {
		window.removeEventListener("scroll", this.scrollHandler, true);
		window.removeEventListener("click", this.hideOnClickOutside);
	},
};
</script>
<style scoped>
.v-contextual__content {
	position: fixed;
}
</style>
